module.exports = __webpack_public_path__ + "media/images/proof_links/steam-b4dae17603b5b399440257f84080f31c.svg";